import React, { useContext, useState } from 'react'
import Modal from 'react-modal'
import CarImg from '../../assets/images/carro.png'
import PeopleImg from '../../assets/images/pessoas.png'
import Check from '../../assets/svgs/Check.js'
import Button from '../../components/Button'
import Checkbox from '../../components/Checkbox'

import { objInfomationsTable, objPrices } from '../../constants/SectionHome'
import IconClose from '../../assets/images/icon-close.png'
import './style.scss'

import ModalError from '../../components/ModalError'

import { AppContext } from '../../store'

export default function SectionHomeDesktop() {
	const { state, openPromotion } = useContext(AppContext)
	const [checkTerm, setCheckTerm] = useState(false)
	const [checkTerm2, setCheckTerm2] = useState(false)
	const [modalIsOpen, setModalIsOpen] = useState(false)
	let {codeErrorModalIsOpen} = useState(true)
	
	codeErrorModalIsOpen = state.codigomgm ? false : true;

	const disableBtn = () => {
		setCheckTerm(!checkTerm)
	}
	
	const disableBtn2 = () => {
		setCheckTerm2(!checkTerm2)
	}

	const showModalTerm = () => {
		document.body.style.overflow = "hidden";
		setModalIsOpen(!modalIsOpen)
	}

	const closeModalTerm = () => {
		document.body.style.overflow = "auto";
		setModalIsOpen(false)
	}

	const toPlans = () => {
		document.getElementById("home").scrollIntoView()
	}

	const customStyles = {
		content: {
		}
	}

	return (
		<>	
			<ModalError
				codeErrorModalIsOpen={codeErrorModalIsOpen}
			/>

			<section class="section-home-container">
				<section>
					<div className="title-container">
						<div class="title-container--content">
							<h1>Amigo que é amigo<br /> tira o outro da fila. ;)</h1>
							<p>
								Tem alguém querendo descomplicar seu caminho! Que tal dar <strong>adeus às filas</strong> de pedágios e estacionamentos?<br /> 
								Com a indicação do seu amigo, você ganhou <strong>{state.mainBonus} mensalidades grátis,</strong> sem fidelidade.
							</p>
							<button class="btn cta" onClick={toPlans}>Peça já</button>
						</div>
						<div className="image-container">
							<img src={PeopleImg} alt="car" />
						</div>
					</div>

					<div className="plans-container">
						<div className="container-title">
							<div className="logo-container">
								<img className="logo" alt="Carro" src={CarImg} />
							</div>
							<div className="text-container">
								<h1>Conheça os planos e as vantagens que temos pra você:</h1>
							</div>

						</div>
						<table>
							<tr id="home">
								{objInfomationsTable.map(({ title, classBlock, classTitle, subtitle, classParagraph1, paragraph1, classParagraph2, paragraph2 }) => {
									return (
										<th className={`infomation calibri ${classBlock}`}>
											{title && (
												<div className={classTitle}>
													{title}
												</div>
											)}

											{subtitle && (
												<div className="subtitle">
													{subtitle}
												</div>
											)}

											{paragraph1 && (
												<div className="paragraph mb10">{paragraph1}</div>
											)}

											{paragraph2 && (
												<div className={`${classParagraph2} paragraph`}>{paragraph2}</div>
											)}
										</th>
									)
								})}
							</tr>
						</table>

						<hr className="divider" />

						<table>
							<tr>
								<th className="calibri text-initial bold">
									Tempo de isenção
								</th>
								<th className="calibri bold">
									{state.mainBonus} mensalidades grátis
								</th>
								<th className="calibri bold">
									{state.mainBonus} mensalidades grátis
								</th>
							</tr>
							{
								objPrices.map(({ title, information1, information2, classPrice }) => (
									<tr className="calibri">
										<td className={`title calibri f18 ${classPrice ? classPrice : ''}`}>{title}</td>
										<td className={`tc calibri f18 ${classPrice ? classPrice : ''}`}>
											{
												information1 === 'Check' ?
													<Check /> :
													information1
											}
										</td>
										<td className={`tc ${classPrice ? classPrice : ''}`}>
											{
												information2 === 'Check' ?
													<Check /> :
													information2
											}
										</td>
									</tr>
								))
							}
							<tr>
								<td className={`title bold calibri`}>Mensalidade após {state.mainBonus} meses</td>
								<td className={`tc bold calibri`}>
									R$ 18,90
								</td>
								<td className={`tc bold calibri`}>
									R$ 20,90
								</td>
							</tr>

							<tr>
								<th></th>
								<th>
									<div className="checkbox-container">
										<Checkbox onChange={disableBtn} />
										<span>Estou ciente que, ao prosseguir, aceito os <span className="underline" onClick={showModalTerm}>termos e condições</span> da campanha</span>
									</div>
									<div>
										<Button 
											onClick={openPromotion('PRE')} 
											text="Quero Pré-Pago"
											disabled={!checkTerm} 
										/>
									</div>
								</th>
								<th>
									<div className="checkbox-container">
										<Checkbox onChange={disableBtn2}/>
										<span>Estou ciente que, ao prosseguir, aceito os <span className="underline" onClick={showModalTerm}>termos e condições da campanha</span></span>
									</div>
									<div>
										<Button 
											onClick={openPromotion('POS')} 
											text="Quero Pós-Pago" 
											disabled={!checkTerm2}
										/>
									</div>
								</th>
							</tr>
						</table>
					</div>
				</section>
			</section>
			<Modal
				isOpen={modalIsOpen}
				onRequestClose={closeModalTerm}
				style={customStyles}
				contentLabel="Example Modal"
			>
				<div className="modal-desk">
					<div className="modal-header">
						<button className="btn-close" onClick={closeModalTerm}>
							<img alt="Icon Close" src={IconClose} />
						</button>
					</div>
					<div className="title" style={{ textAlign: 'center' }}>
						<h3>{state.regulamento.title.toUpperCase()}</h3>
					</div>
					<div className="modal-container calibri" dangerouslySetInnerHTML={{__html: state.regulamento.content}} />
				</div>
			</Modal>
		</>
	)

}